export default __webpack_public_path__ + "static/media/view.a9e68c62.png";